export const graphUrl = process.env.GRAPH_URL || "no-graphQL-url";
